import { Route } from "react-router-dom";
import React, { Suspense } from "react";
import { all_routes } from "./all_routes";
import CenteredLoader from "../common/component/CenteredLoader";
import UsreList from "../feature-modules/userManagement";
import UserPage from "../feature-modules/userManagement/userpage";
import ComparativeDashboard from "../feature-modules/comparativeDashboard/pages/ComparativeDashboard";

// Lazy load the components
const Dashboard = React.lazy(
  () => import("../feature-modules/dashboard/dashboard")
);
const CustSuppLogin = React.lazy(
  () => import("../feature-modules/userManagement/custsupplogin")
);
const DynamicPage = React.lazy(() => import("../feature-modules/dynamicpages"));
const DynamicTable = React.lazy(
  () => import("../feature-modules/dynamicpages/dynamictable")
);
const ReceiptPage = React.lazy(() => import("../feature-modules/receipt"));
const Signin = React.lazy(
  () => import("../feature-modules/authentication/login/signin")
);
const Company_Page = React.lazy(() => import("../feature-modules/maincompany"));
const VoucherList = React.lazy(() => import("../feature-modules/voucher"));
const OrderPage = React.lazy(() => import("../feature-modules/order"));
const CataloguePage = React.lazy(() => import("../feature-modules/catalogue"));
const routes = all_routes;

export const publicRoutes = [
  {
    id: 1,
    path: routes.dashboard,
    name: "Dashboard",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Dashboard />
      </Suspense>
    ),
    route: Route,
  },
  {
    id: 2,
    path: routes.dynamicpage,
    name: "Pages",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <DynamicPage />
      </Suspense>
    ),
    route: Route,
  },
  {
    id: 3,
    path: routes.userlist,
    name: "User List",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <UsreList />
      </Suspense>
    ),
    route: Route,
  },
  {
    id: 4,
    path: routes.userpage,
    name: "User Page",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <UserPage />
      </Suspense>
    ),
    route: Route,
  },
  {
    id: 5,
    path: routes.catalogue,
    name: "Catalogue",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <CataloguePage />
      </Suspense>
    ),
    route: Route,
  },
  {
    id: 6,
    path: routes.custsupplogin,
    name: "custsupplogin",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <CustSuppLogin />
      </Suspense>
    ),
    route: Route,
  },
  {
    id: 7,
    path: routes.comperitiveDashboard1,
    name: "comperitiveDashboard1",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <ComparativeDashboard type="sales"/>
      </Suspense>
    ),
    route: Route,
  },
  {
    id: 8,
    path: routes.comperitiveDashboard2,
    name: "comperitiveDashboard2",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <ComparativeDashboard type="purchase" />
      </Suspense>
    ),
    route: Route,
  },
];

//================================routes for pages without auth=====================================================

export const pagesRoute = [
  {
    id: 1,
    path: routes.signin,
    name: "signin",
    element: (
      <Suspense fallback={<CenteredLoader />}>
        <Signin />
      </Suspense>
    ),
    route: Route,
  },
  {
    id: 2,
    path: routes.company,
    name: "Company",
    element: (
      <Suspense fallback={<CenteredLoader />}>
        <Company_Page />
      </Suspense>
    ),
    route: Route,
  },
  {
    id: 3,
    path: routes.dynamiclist,
    name: "Pages List",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <DynamicTable />
      </Suspense>
    ),
    route: Route,
  },
  {
    id: 4,
    path: routes.voucherList,
    name: "Pages List",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <VoucherList />
      </Suspense>
    ),
    route: Route,
  },
  {
    id: 5,
    path: routes.order,
    name: "Order List",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <OrderPage type="order" />
      </Suspense>
    ),
    route: Route,
  },
  {
    id: 6,
    path: routes.purchase,
    name: "Purchase List",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <OrderPage type="purchase" />
      </Suspense>
    ),
    route: Route,
  },
  {
    id: 7,
    path: routes.receipt,
    name: "Receipt",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <ReceiptPage />
      </Suspense>
    ),
    route: Route,
  },
];
